module.exports = __webpack_public_path__ + "media/images/gallery/constellations/border_layer_off-1365557293bf7c98c17cb93d9cb79524.jpg";